module.exports = __webpack_public_path__ + "img/proceso-simple.2610dae6.svg";